import { VIDEO_PLACEHOLDER_CLASS } from "components/mini/Loom/EmbeddedVideo"

// TODO: use loom-embed library so this isn't dependant on the url format staying the same
// This would also theoretically give us aspect ratios without having to put them in the
// text, but that feature currently doesn't work properly
const loomEmbedRegex = /^(?<src>https:\/\/www.loom.com\/embed\/\w*)(?: r:(?<ratio>\d*\.?\d*))?$/
export const getLoomDataFromLink = str => {
  const extracted = loomEmbedRegex.exec(str)
  return extracted ? extracted.groups : null
}

const loomPlaceholderDivRegex = new RegExp(`<div[^>]*class=[-"'\\w\\s]*${VIDEO_PLACEHOLDER_CLASS}[^>]*>`)
export const containsLoomVideo = content =>
  loomPlaceholderDivRegex.test(content)
